import { useState } from "react";

const useMessageManager = () => {
  return useState("");
};

export default useMessageManager;
